import request from '@/utils/userRequest'
let baseUrl_old = 'MetaWorks/api/v1/DigitalHuman/' //已废弃20240509hxn&&zjx
let baseUrl = '/MetaWorks/api/user/' //新接口路径
const userApi = {
  Login: '/auth/login',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: 'v1/user/account/sms',
  SendSmsErr: 'v1/user/account/sms_err',
  // get my info
  UserInfo: '/user/info',
  UserMenu: '/user/nav',
}
export function login(parameter) {
  return request({
    url: baseUrl + 'v1/user/login',
    method: 'post',
    data: parameter,
  })
}
// 用户注册
export function register(data) {
  return request({
    url: baseUrl + 'v1/user/register',
    method: 'post',
    data,
  })
}
export function getLoginSmsCode(parameter) {
  return request({
    url: baseUrl + `v1/user/login/getLoginSmsCode?phone=${parameter.phone}`,
    method: 'get',
    // data: parameter,
  })
}

export function smsLogin(params) {
  return request({
    url: baseUrl + `v1/user/login/phone`,
    method: 'post',
    data: params,
  })
}
export function logout(name) {
  return request({
    url: baseUrl + `v1/user/logout?username=${name}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}
export function getInfo() {
  return request({
    url: baseUrl + 'v1/user/currUserInfo',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}
export function getBusinessInfo() {
  return request({
    url: baseUrl + 'v1/user/detail',
    method: 'get',
  })
}
export function getBusinessList() {
  return request({
    url: baseUrl + 'v1/user/list',
    method: 'get',
  })
}
/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login_old() {
  return request({
    url: userApi.Login,
    method: 'get',
  })
}

export function getSmsCaptcha(parameter) {
  return request({
    url: userApi.SendSms,
    method: 'post',
    data: parameter,
  })
}

export function getInfo_old() {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}

export function getCurrentUserNav() {
  return request({
    url: userApi.UserMenu,
    method: 'get',
  })
}

export function logout_old() {
  return request({
    url: userApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return request({
    url: userApi.twoStepCode,
    method: 'post',
    data: parameter,
  })
}
export function meituanAuthAPI(params) {
  return request({
    url: '/MetaWorks/api/user/v1/mt/bindAuthToken',
    method: 'get',
    params,
  })
}

//1.8.2
/**
 * 账号密码登录
 */
export function loginByPasswordAPI(data) {
  return request({
    url: '/MetaWorks/api/user/' + 'v1/user/login',
    method: 'post',
    data,
  })
}
/**
 * 手机号登录
 */
export function loginByPhoneAPI(data) {
  return request({
    url: '/MetaWorks/api/user/' + 'v1/user/login/phone',
    method: 'post',
    data,
  })
}
/**
 * 检测订阅周期
 */
export function checkSubscriptionAPI() {
  return request({
    url: '/MetaWorks/api/digitalhuman/v1/userPermission/platformExpireCheck',
    method: 'get',
  })
}
